import { Component, HostListener, Input, OnChanges, Output, SimpleChanges, EventEmitter } from '@angular/core';
@Component({
  selector: 'app-preview',
  templateUrl: './preview.component.html',
  styleUrls: ['./preview.component.scss'],
})
export class PreviewComponent implements OnChanges {
  @Input() pdfBytes!: Uint8Array;
  @Output() emitCloseEvent: EventEmitter<boolean> = new EventEmitter();

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    this.pdfBytes = changes.pdfBytes.currentValue;
  }

  @HostListener('contextmenu', ['$event'])
  onRightClick(event: Event) {
    event.preventDefault();
  }

  @HostListener('click', ['$event'])
  onClick(event: Event) {
    event.preventDefault();
  }

  @HostListener('dblclick', ['$event'])
  onDblClick(event: Event) {
    event.preventDefault();
  }

  @HostListener('touch', ['$event'])
  onTouch(event: Event) {
    event.preventDefault();
  }

  @HostListener('select', ['$event'])
  onSelect(event: Event) {
    event.preventDefault();
  }

  @HostListener('copy', ['$event'])
  onCopy(event: Event) {
    event.preventDefault();
  }

  @HostListener('cut', ['$event'])
  onCut(event: Event) {
    event.preventDefault();
  }

  @HostListener('window:print', ['$event'])
  onWindowBeforePrint(event: Event) {
    event.preventDefault();
  }

  closePreview() {
    this.emitCloseEvent.emit(false);
  }
}
